<h1 mat-dialog-title>Materieel van voorgaande dagen</h1>
<div mat-dialog-content>
    @if (!realisationList?.length && !!realisationList) {
        <div>Er zijn geen materieelstukken die overgenomen kunnen worden van voorgaande dagen.</div>
    } @else if (!realisationList) {
        <div>Laden...</div>
    }
    <mat-selection-list [formControl]="fcEntities">
        @for (entity of realisationList; track entity) {
            @for (i of [].constructor(entity.count); track i) {
                <mat-list-option [value]="entity">
                    <div mat-line>{{ entity.name }}</div>
                    <div mat-line>
                        <i>Gebruikt op: </i>
                        @for (r of entity.realisations; track r; let last = $last) {
                            {{ r.bookdate | date: 'EEE d MMM' }}{{ last ? '' : ', ' }}
                        }
                    </div>
                </mat-list-option>
            }
        }
    </mat-selection-list>
</div>
<div class="d-flex flex-wrap pt-3" mat-dialog-actions>
    <button mat-button mat-dialog-close>Annuleren</button>
    <div class="spacer"></div>
    <button (click)="take()" mat-raised-button cdkFocusInitial color="primary">Overnemen</button>
</div>
